import axios from "axios";
import UserService from "./UserService";

const _axios = axios; //.create();

const _axiosNoInterceptors = axios.create();

// Cấu hình authorization cho instance không có interceptors
_axiosNoInterceptors.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${UserService.getToken()}`;
  return config;
});

const configure = () => {
  // _axios.interceptors.request.use((config) => {
  //   const cb = () => {
  //     config.headers.Authorization = `Bearer ${UserService.getToken()}`;
  //     return Promise.resolve(config);
  //   };
  //   return UserService.updateToken(cb);
  // });
};

const getAxiosClient = () => _axiosNoInterceptors;

export default { configure, getAxiosClient };
